import logo from '../assets/logo.png';

import bnrBG from '../assets/bnrBG.png';
import girl from '../assets/girl.png';

import icoAdmin from '../assets/icoAdmin.png';
import icoConstruction from '../assets/icoConstruction.png';
import icoHotel from '../assets/icoHotel.png';
import icoIT from '../assets/icoIT.png';
import icoLogistic from '../assets/icoLogistic.png';
import icoPedagogy from '../assets/icoPedagogy.png';
import icoSales from '../assets/icoSales.png';
import imgAdmin from '../assets/imgAdmin.png';
import imgConstruction from '../assets/imgConstruction.png';
import imgHotel from '../assets/imgHotel.png';
import imgIT from '../assets/imgIT.png';
import imglogistic from '../assets/imglogistic.png';
import imgPedagogy from '../assets/imgPedagogy.png';
import imgSales from '../assets/imgSales.png';

import aboutImg from '../assets/aboutImg.png';

import icoLifeAndWork from '../assets/icoLifeAndWork.png';
import icoPerfection from '../assets/icoPerfection.png';
import icoPersonalDev from '../assets/icoPersonalDev.png';

import opportunitiesImg from '../assets/opportunitiesImg.png';

import prt01 from '../assets/prt01.png';
import prt02 from '../assets/prt02.png';
import prt03 from '../assets/prt03.png';
import prt04 from '../assets/prt04.png';
import prt05 from '../assets/prt05.png';
import prt06 from '../assets/prt06.png';
import prt07 from '../assets/prt07.png';
import prt08 from '../assets/prt08.png';
import prt09 from '../assets/prt09.png';
import prt10 from '../assets/prt10.png';
import prt11 from '../assets/prt11.png';
import prt12 from '../assets/prt12.png';
import prt13 from '../assets/prt13.png';
import iconSearch from '../assets/iconSearch.png';
import iconHeart from '../assets/iconHeart.png';
import iconChart from '../assets/iconChart.png';


export default {
    logo,
    bnrBG,
    girl,
    icoAdmin,
    icoConstruction,
    icoHotel,
    icoIT,
    icoLogistic,
    icoPedagogy,
    icoSales,
    imgAdmin,
    imgConstruction,
    imgHotel,
    imgIT,
    imglogistic,
    imgPedagogy,
    imgSales,
    aboutImg,
    icoLifeAndWork,
    icoPerfection,
    icoPersonalDev,
    opportunitiesImg,
    prt01,
    prt02,
    prt03,
    prt04,
    prt05,
    prt06,
    prt07,
    prt08,
    prt09,
    prt10,
    prt11,
    prt12,
    prt13,
    iconSearch,
    iconHeart,
    iconChart,
};